import { useCallback, useEffect, useState } from 'react';
import { PartnerSchool } from '../types/partnerSchools';
import { fetchPartnerSchools } from '../services/partnerSchoolsService';

interface UsePartnerSchoolsReturn {
    schools: PartnerSchool[];
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<void>;
}

/**
 * Loads partner school logos for the public landing page. The service fails
 * open (returns an empty list) so the section can be hidden entirely when the
 * CMS returns no logos or is unavailable.
 */
export function usePartnerSchools(): UsePartnerSchoolsReturn {
    const [schools, setSchools] = useState<PartnerSchool[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            const data = await fetchPartnerSchools();
            setSchools(data);
            setError(null);
        } catch (err) {
            setError(err as Error);
            setSchools([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { schools, loading, error, refetch: load };
}
